import { OrganizationSignupCompletedEvent } from '@rematter/frontend-lib-api-client/grpc/core/v1/organization_events_pb';
import { Col } from '@rematter/ui-web';
import { FieldDisplay, IDField } from '@rematter/ui-web';

type OrganizationSignupCompletedDetailProps = {
  event: OrganizationSignupCompletedEvent;
};

export const OrganizationSignupCompletedDetail = ({
  event,
}: OrganizationSignupCompletedDetailProps) => {
  const organization = event.organization;

  if (!organization) {
    return (
      <Col className="@OrganizationSignupCompletedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  return (
    <Col className="@OrganizationSignupCompletedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          Organization Details
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={organization.id?.value} />
          <FieldDisplay label="Name" value={organization.name} />
          <FieldDisplay label="Domain" value={organization.domain} />
        </div>
      </Col>

      <Col
        className="rounded-md border border-success/20 bg-success/5 p-3"
        gap2
      >
        <span className="text-xs font-medium text-success/80">
          Signup Completed
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="User ID" value={event.userId?.value} />
          <IDField label="Facility ID" value={event.facilityId?.value} />
        </div>
      </Col>
    </Col>
  );
};
